import React, { useEffect, lazy } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export const FullPortfolio: React.FC = () => {
  const navigate = useNavigate();
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const portfolioItems = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8PztJeWLcR26gEKZ21momC/916450430006_websize.jpg',
    alt: 'Wedding bouquets with peach and white flowers'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/staUEBHwqzJqniSxHMc6xZ/2Q7A5960_websize.jpg',
    alt: 'Elegant outdoor table setting under tropical trees'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dw6SgnenpQqGi39NnoLdaD/2Q7A5762_websize.jpg',
    alt: 'Garden wedding ceremony under tree with string lights'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9AWGKbZN4XvcfP8CAavW6Y/DSCF4801_websize.jpg',
    alt: 'Bride with parents in tropical garden setting'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/opfbjAdM29oVpxtdH9Aew6/CC3A2315_websize.jpg',
    alt: 'Wedding menu card in floral arrangement'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/73t2GLYSjGt3Rpv4aJmmzN/DSCF4977_websize.jpg',
    alt: 'Bride and groom celebrating with raised arms'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/v1LfxQfzsRpV156zfBXfym/CC3A1994_websize.jpg',
    alt: 'White fluffy dog in blue bow tie at wedding'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8mfL1MsMey2a4oM5VcvQBc/DSCF5195_websize.jpg',
    alt: 'Bride and groom at sweetheart table with floral runner'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rk9YD5nsBHndFaSb4i1GtL/2Q7A5918_websize.jpg',
    alt: 'Table number frame with childhood photos and orange flowers'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/si9UVvG65zQt7jBkpE69Rb/DSCF4865_websize.jpg',
    alt: 'Wedding party celebrating with drinks in tropical garden'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8dpXQXGGF6T4LvdfQvUEZj/DSCF4882_websize.jpg',
    alt: 'Guests toasting with colorful cocktails outdoors'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gkE3FB41tna5qZaEjVp2gR/916450510012_websize.jpg',
    alt: 'Full outdoor reception setup with string lights and umbrellas'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nKsmfVaKrDys44dJznUYZs/DSCF5008_websize.jpg',
    alt: 'Bride and groom portrait with bouquet'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/v8wikbvsfg5Tuy3quGL2U2/CC3A2326_websize.jpg',
    alt: 'Cards and gifts table with orchids and candles'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/71u9zCK4wPeeiLyG768cii/CC3A2927_websize.jpg',
    alt: 'Couple with vintage car and paper lanterns'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kahaTyW8ERvghJzcK49Y8k/2Q7A6407_websize.jpg',
    alt: 'Outdoor lounge area with fire pit and string lights'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vKCJyRYeVFJTrfhs8nbsZ/DSCF5466_websize.jpg',
    alt: 'Three-tier white wedding cake with orange and yellow flowers'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/d2mTZJ229XPUChredqFtwQ/2Q7A6291_websize.jpg',
    alt: 'Couple at bar with orchid decorations and string lights'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iw55y9Qzh2KJ7mCFnJHDXt/916450740005_websize.jpg',
    alt: 'Couple kissing while cutting wedding cake at dusk'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6ztdYt6ZYTx7uLApkzfCgH/DSCF4918_websize.jpg',
    alt: 'Orange and blue floral centerpiece arrangement'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/73cYj4i7CghXrKLriWE93p/2Q7A7861_websize.jpg',
    alt: 'First dance with groom lifting bride'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3QkWSxWGCNYh9yjkKeY7fN/916450720017_websize.jpg',
    alt: 'Groomsmen suits hanging on wooden branch'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oEnyECXEUKWEaC3qZ8R1wF/DSCF5406_websize.jpg',
    alt: 'Groomsmen toasting at outdoor reception'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bxY6dt6k5tLk8yYX9E4PZy/2Q7A4471_websize.jpg',
    alt: 'Wedding dresses hanging in elegant setting'
  }];
  return <>
      <Helmet data-id="element-171">
        <title data-id="element-172">
          Wedding Portfolio | Moonstone Events | Bay Area Celebrations
        </title>
        <meta name="description" content="Explore our portfolio of beautiful Bay Area weddings. From intimate ceremonies to grand celebrations, see how Moonstone Events brings each couple's unique vision to life." data-id="element-173" />
        <meta name="keywords" content="wedding portfolio, bay area weddings, san francisco wedding photos, wedding inspiration, real weddings, wedding gallery, wedding planner portfolio" data-id="element-174" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Wedding Portfolio | Moonstone Events" data-id="element-175" />
        <meta property="og:description" content="Explore our portfolio of beautiful Bay Area weddings and celebrations" data-id="element-176" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8PztJeWLcR26gEKZ21momC/916450430006_websize.jpg" data-id="element-177" />
        <meta property="og:url" content="https://moonstoneevents.com/portfolio" data-id="element-178" />
        <meta property="og:type" content="website" data-id="element-179" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-180" />
        <meta name="twitter:title" content="Wedding Portfolio | Moonstone Events" data-id="element-181" />
        <meta name="twitter:description" content="Explore our portfolio of beautiful Bay Area weddings and celebrations" data-id="element-182" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8PztJeWLcR26gEKZ21momC/916450430006_websize.jpg" data-id="element-183" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://moonstoneevents.com/portfolio" data-id="element-184" />
      </Helmet>

      <Header data-id="element-185" />

      <div className="min-h-screen bg-white pt-[72px]" data-id="element-186">
        {/* Page Title */}
        <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8 border-b border-gray-100" data-id="element-187">
          <div className="max-w-7xl mx-auto text-center" data-id="element-188">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-[#486878]" data-id="element-189">
              Portfolio
            </h1>
          </div>
        </section>

        {/* Portfolio Grid */}
        <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-190">
          <div className="max-w-7xl mx-auto" data-id="element-191">
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8" data-id="element-192">
              {portfolioItems.map((item, index) => <div key={index} className="relative aspect-[3/4] overflow-hidden bg-white transition-transform duration-300 group hover:scale-[1.02]" data-id="element-193">
                  <img src={item.image} alt={item.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" data-id="element-194" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-195" />
                </div>)}
            </div>
          </div>
        </section>
      </div>

      <Footer data-id="element-196" />
    </>;
};